import { render, staticRenderFns } from "./ContentsContainer.vue?vue&type=template&id=125199d8"
import script from "./ContentsContainer.vue?vue&type=script&lang=js"
export * from "./ContentsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports